module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/fantasy-invest/1.gif?3b05468ac43126e149cd0a8fc6438d84";